(() => {
  const initialized=new WeakSet();
  const initialize=()=>document.querySelectorAll('.yeefine-header').forEach(header=>{
    if(initialized.has(header))return;initialized.add(header);
    let active=null,timer=null,suppressFocus=false;
    const close=()=>{if(!active)return;active.menu.classList.remove('is-open');active.trigger.setAttribute('aria-expanded','false');active=null};
    const open=(menu,trigger)=>{clearTimeout(timer);if(active&&active.menu!==menu)close();menu.querySelectorAll('template[data-yf-menu-image]').forEach(image =>
      image.replaceWith(image.content.cloneNode(true)));
      menu.classList.add('is-open');trigger.setAttribute('aria-expanded','true');active={menu,trigger}};
    header.querySelectorAll('.yeefine-header__nav-list>li>a[aria-controls]').forEach(trigger=>{
      const menu=document.getElementById(trigger.getAttribute('aria-controls'));if(!menu)return;
      const item=trigger.parentElement;
      item.addEventListener('mouseenter',()=>open(menu,trigger));
      item.addEventListener('mouseleave',()=>{timer=setTimeout(close,170)});
      menu.addEventListener('mouseenter',()=>clearTimeout(timer));
      menu.addEventListener('mouseleave',()=>{timer=setTimeout(close,170)});
      trigger.addEventListener('focus',()=>{if(!suppressFocus)open(menu,trigger)});
      trigger.addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();open(menu,trigger);menu.querySelector('a')?.focus()}});
      item.addEventListener('focusout',event=>{if(!item.contains(event.relatedTarget))close()});
    });
    header.addEventListener('keydown',event=>{if(event.key==='Escape'&&active){const trigger=active.trigger;clearTimeout(timer);close();suppressFocus=true;trigger.focus();queueMicrotask(()=>suppressFocus=false)}});
    document.addEventListener('pointerdown',event=>{if(!header.contains(event.target))close()});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
